import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { isUserImpersonated } from '../selectors/AuthSelector';
import { isRestrictedImpersonatee } from '../selectors/IsRestrictedImpersonateeSelector';
import { jsx as _jsx } from "react/jsx-runtime";
export const ImpersonationAlert = ({
  showAlert
}) => {
  if (!showAlert) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    type: "tip",
    marginBlockEnd: "500",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "userPreferences.impersonationToolTip"
    })
  });
};
ImpersonationAlert.propTypes = {
  showAlert: PropTypes.bool.isRequired
};
const mapStateToProps = state => {
  return {
    showAlert: isUserImpersonated(state) && !isRestrictedImpersonatee(state)
  };
};
export default connect(mapStateToProps, {})(ImpersonationAlert);